import ApiClient from '@/api/ApiClient';
import UserGrade from '@/api/models/UserGrade';

class UserGradeService {
    #prefixUrl = 'api/user_grade/';

    constructor() {
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Gets all of logged user courses
     * Note: Related to student courses
     * @returns {Array} 
     */
    async getByCourse(courseUuid = '') {
        const response = await this.api.executeRequest(`/course/${courseUuid}`, {}, this.api.methods.GET);
        let userGrades = {};
        if (!response.success())
            return userGrades;

        for (let ug of response.getContent()) {
            const userGrade = new UserGrade(ug);
            userGrades[userGrade.lesson] = userGrade;
        }
        response.setContent(userGrades);

        return response;
    }
}

export default new UserGradeService();
